export default "__VITE_ASSET__C15Ti7vM__"